import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import { getMenuItemUrl } from '../../helpers/menu-item';
import Link from '../atoms/Link';
import LogoFullMono from '../atoms/LogoMono';
import Instagram from '../icons/Instagram';
import LinkedIn from '../icons/LinkedIn';
import Twitter from '../icons/Twitter';
import YouTube from '../icons/YouTube';

const Footer = () => {
  const {
    mainMenu: { columns },
    copyrightMenu: { columns: copyrightColumns },
  } = useStaticQuery(graphql`
    {
      mainMenu: contentfulMenu(location: { eq: "Footer" }) {
        name
        columns {
          heading
          items {
            label
            targetPage {
              url
            }
            externalUrl
          }
        }
      }
      copyrightMenu: contentfulMenu(location: { eq: "Footer Copyright" }) {
        columns {
          items {
            label
            targetPage {
              url
            }
            externalUrl
          }
        }
      }
    }
  `);

  const copyrightItems = copyrightColumns[0].items;

  return (
    <footer className="pt-20 pb-16 text-white bg-[#011E37]">
      <div className="container">
        <div className="flex flex-wrap justify-between">
          <div className="w-full mb-12 md:w-3/12 lg:w-4/12 md:mb-0">
            <Link
              href="/"
              className="inline-block rounded-sm u-ring focus:ring-offset-2 focus:outline-none ring-offset-slate-900"
              aria-label="StackScout"
            >
              <LogoFullMono className="w-auto h-10" />
            </Link>
          </div>

          {columns.map(({ heading, items }, index) => (
            <div
              className="w-6/12 mb-12 md:flex-1 md:px-4 md:w-auto xl:px-0 md:mb-0"
              key={index}
            >
              <h2 className="mb-6 text-xs font-semibold uppercase text-slate-400">
                {heading}
              </h2>
              <ul className="space-y-3">
                {items.map((item, index) => (
                  <li key={index}>
                    <Link
                      className="text-sm text-white transition hover:text-primary focus:text-primary u-ring"
                      href={getMenuItemUrl(item)}
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="flex flex-col items-center justify-between py-4 space-y-6 border-t md:mt-8 lg:mt-12 lg:space-y-0 lg:flex-row border-slate-700">
          <div className="flex flex-col items-center justify-between w-full space-y-4 text-xs font-medium md:space-y-0 md:flex-row lg:w-auto lg:justify-start">
            <div className="opacity-60">
              &copy; {new Date().getFullYear()} StackScout. All rights reserved.
            </div>
            <div className="space-x-4 md:pl-8">
              {copyrightItems.map((item, index) => (
                <Link
                  key={index}
                  className="transition opacity-60 hover:opacity-100 focus:opacity-100 u-ring"
                  href={getMenuItemUrl(item)}
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </div>
          <div className="flex items-center space-x-6">
            <Link
              className="transition rounded-sm opacity-50 hover:opacity-100 focus:opacity-100 u-ring focus:ring-offset-2 focus:ring-offset-slate-900"
              href="https://www.youtube.com/@StackScout"
              aria-label="YouTube"
            >
              <YouTube className="w-auto h-4" />
            </Link>
            <Link
              className="transition rounded-sm opacity-50 hover:opacity-100 focus:opacity-100 u-ring focus:ring-offset-2 focus:ring-offset-slate-900"
              href="https://twitter.com/StackScout"
              aria-label="Twitter"
            >
              <Twitter className="w-auto h-4" />
            </Link>
            <Link
              className="transition rounded-sm opacity-50 hover:opacity-100 focus:opacity-100 u-ring focus:ring-offset-2 focus:ring-offset-slate-900"
              href="https://linkedin.com/company/StackScout"
              aria-label="LinkedIn"
            >
              <LinkedIn className="w-auto h-4" />
            </Link>
            <Link
              className="transition rounded-sm opacity-50 hover:opacity-100 focus:opacity-100 u-ring focus:ring-offset-2 focus:ring-offset-slate-900"
              href="https://instagram.com/StackScout"
              aria-label="Instagram"
            >
              <Instagram className="w-auto h-4" />
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
